import Contact from ".";

export const contactRoutes = (data) => {
  return [
    {
      path: "/admin/contacts",
      title: "contacts",
      layout: "admin",
      routeType: "admin",
      component: Contact,
    },
  ];
};
